
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface LikertScaleProps {
  value: number;
  onChange: (value: number) => void;
  labels?: string[];
}

const LikertScale: React.FC<LikertScaleProps> = ({ 
  value, 
  onChange,
  labels = ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"] 
}) => {
  return (
    <div className="w-full">
      <div className="flex justify-between mb-2">
        {labels.map((label, index) => (
          <div key={index} className="flex flex-col items-center">
            <button
              onClick={() => onChange(index + 1)}
              className={cn(
                "w-10 h-10 rounded-full border-2 transition-all duration-200 flex items-center justify-center",
                value === index + 1 
                  ? "border-morgenViolet bg-morgen-gradient text-white" 
                  : "border-gray-300 bg-white hover:border-morgenBlue"
              )}
            >
              {value === index + 1 && (
                <motion.div 
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="w-3 h-3 rounded-full"
                />
              )}
            </button>
            <span className="text-xs text-gray-600 mt-2 text-center">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LikertScale;
